export const blackAndWhite = [
  '#CAD0D8',
  '#B6BEC9',
  '#98A4B3',
  '#6C7C93',
  '#576375',
  '#303740',
  '#303740',
];

export const colorFull = [
  '#4254FB',
  '#2E96FF',
  '#54C690',
  '#FFB219',
  '#FF7A19',
  '#F73B4B',
  '#F286B3',
];

export const sxColors = {
  // '--palette-color-0': blackAndWhite[0],
  // '--palette-color-1': blackAndWhite[1],
  // '--palette-color-2': blackAndWhite[2],
  // '--palette-color-3': blackAndWhite[3],
  // '--palette-color-4': blackAndWhite[4],
  // '--palette-color-5': blackAndWhite[5],
  // '--palette-color-6': blackAndWhite[6],

  // '&:hover': {
  '--palette-color-0': colorFull[0],
  '--palette-color-1': colorFull[1],
  '--palette-color-2': colorFull[2],
  '--palette-color-3': colorFull[3],
  '--palette-color-4': colorFull[4],
  '--palette-color-5': colorFull[5],
  '--palette-color-6': colorFull[6],
  // },
};
